export default __webpack_public_path__ + "static/media/hotpower.00f0874f.jpg";